import type {OffersRequest} from '@yandex-delivery/types/logistic-dispatcher/external-api'

import type {FetchTimeIntervalsQuery} from '../types'

export function toOffersInfoBody(params: FetchTimeIntervalsQuery): OffersRequest {
  return {
    source: {
      platform_station_id: params.station_id,
    },
    destination: {
      platform_station_id: 'self_pickup_id' in params ? params.self_pickup_id : undefined,
      address: 'full_address' in params ? params.full_address : undefined,
    },
    places: params.places,
  }
}
